import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../../../features/language/useLanguage';
import { Button } from '../../common/Button';

interface ResultStepProps {
  count: number;
  onDone: () => void;
}

export const ResultStep: React.FC<ResultStepProps> = ({ count, onDone }) => {
  const { t } = useLanguage();
  const message = t('inventory.import.successToast').replace(
    '{{count}}',
    String(count),
  );
  return (
    <div className="flex flex-col items-center justify-center py-10 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100 ring-8 ring-green-50">
        <CheckCircle2 className="h-8 w-8 text-green-600" />
      </div>
      <h3 className="mt-4 text-lg font-semibold text-gray-900">{message}</h3>
      <p className="mt-1 text-sm text-gray-500">
        New items are now visible in your inventory list.
      </p>
      <div className="mt-6">
        <Button variant="primary" onClick={onDone} data-test-id="import-green-bean-done">
          {t('inventory.import.done')}
        </Button>
      </div>
    </div>
  );
};
